import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue')
  },
  {
    path: '/spinning',
    name: 'Spinning',
    component: () => import('../views/Spinning.vue')
  },
  {
    path: '/test-version-1',
    name: 'Wheel',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/test-version-2',
    name: 'Wheel',
    component: () => import('../views/Test1.vue')
  },
  {
    path: '/result',
    name: 'Result',
    component: () => import('../views/Result.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
